import { render, staticRenderFns } from "./active-user-form.vue?vue&type=template&id=3fc18bd5"
import script from "./active-user-form.vue?vue&type=script&lang=js"
export * from "./active-user-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports